module.exports = __webpack_public_path__ + "img/TBWTTNL_hero.16817e50.png";